import { render, staticRenderFns } from "./milestoneTYDialog.vue?vue&type=template&id=2255888c"
import script from "./milestoneTYDialog.vue?vue&type=script&lang=js"
export * from "./milestoneTYDialog.vue?vue&type=script&lang=js"
import style0 from "./milestoneTYDialog.vue?vue&type=style&index=0&id=2255888c&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports